export const channels = ['Value1', 'Value2', 'Value3'];
const boundsTolerance = 1;
// Dashboard cards/tooltips omit channels the user identified as unused.
export function visibleChannels(sensor) {
    const code = (sensor?.SensorCode || '').trim().toUpperCase();
    if (/^(TMP|RPM)/.test(code)) return channels.slice(0, 1);
    if (code.startsWith('LVL')) return channels.slice(0, 2);
    return channels;
}
export const numberText = value => value == null || !Number.isFinite(Number(value)) ? '—'
    : Number(value).toLocaleString(undefined, { maximumFractionDigits: 3 });
// User-confirmed calibrated channel units; do not infer units for spare channels.
export function channelUnit(sensor, channel = 'Value1') {
    const code = (sensor?.SensorCode || sensor?.PrimarySensorCode || '').trim().toUpperCase();
    if (code.startsWith('LVL')) return { Value1: 'cm', Value2: 'Liter' }[channel] || '';
    if (code.startsWith('INC') && ['Value1', 'Value2'].includes(channel)) return '°';
    if (channel === 'Value1' && code.startsWith('TMP')) return '°C';
    if (channel === 'Value1' && code.startsWith('RPM')) return 'RPM';
    return '';
}
export function channelLabel(sensor, channel = 'Value1') {
    const unit = channelUnit(sensor, channel);
    return unit === 'cm' ? 'Level' : unit === 'Liter' ? 'Volume' : channel;
}
export function readingText(value, sensor, channel = 'Value1') {
    const text = numberText(value);
    const unit = channelUnit(sensor, channel);
    return text === '—' || !unit ? text : `${text} ${unit}`;
}
export function ageText(seconds) {
    if (seconds == null || !Number.isFinite(Number(seconds))) return '—';
    if (seconds < 0) return 'Ahead of database time';
    if (seconds < 60) return `${seconds}s`;
    if (seconds < 3600) return `${Math.floor(seconds / 60)}m ${seconds % 60}s`;
    if (seconds < 86400) return `${Math.floor(seconds / 3600)}h ${Math.floor(seconds % 3600 / 60)}m`;
    return `${Math.floor(seconds / 86400)}d ${Math.floor(seconds % 86400 / 3600)}h`;
}
export function bounds(sensor, channel) {
    const n = channel.slice(-1);
    const min = sensor?.[`MinValue${n}`] ?? null;
    const max = sensor?.[`MaxValue${n}`] > 0 ? sensor[`MaxValue${n}`] : null;
    const invalid = min != null && max != null && min > max;
    return { min, max, invalid,
        alertMin: min == null ? null : Number(min) - boundsTolerance,
        alertMax: max == null ? null : Number(max) + boundsTolerance,
        text: invalid ? 'Invalid bounds'
        : [min != null ? `Min ${readingText(min, sensor, channel)}` : '', max != null ? `Max ${readingText(max, sensor, channel)}` : ''].filter(Boolean).join(' · ') || 'No configured bounds' };
}
